import { render, staticRenderFns } from "./addReceivable.vue?vue&type=template&id=a3316cf0&scoped=true"
import script from "./addReceivable.vue?vue&type=script&lang=js"
export * from "./addReceivable.vue?vue&type=script&lang=js"
import style0 from "./addReceivable.vue?vue&type=style&index=0&id=a3316cf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3316cf0",
  null
  
)

export default component.exports